<script lang="ts">
  import LottiePlayer from '$lib/components/lottie/LottiePlayer.svelte';

  export let className = '';
</script>

<LottiePlayer
  src="/lottie/success.json"
  viewBoxSize="350 350 1300 1300"
  autoplay
  {className}
  on:complete
  on:loopComplete
/>
